module.exports = __webpack_public_path__ + "img/official_account.907ddfa7.png";